<script lang="ts" setup>
  import Card from 'primevue/card'
  import Skeleton from 'primevue/skeleton'

  defineProps({
    isLeads: Boolean,
  })
</script>

<template>
  <div class="col col-12 sm:col-6 md:col-4 flex-grow-1 p-0" style="min-height: 300px">
    <Card class="w-full h-full">
      <template #title>
        <h2><Skeleton /></h2>
      </template>

      <template #content>
        <div class="w-full flex flex-column mb-3">
          <div class="mb-3 text-600 overflow-hidden white-space-nowrap" style="text-overflow: ellipsis">
            <Skeleton width="60%" />
          </div>
          <div class="mb-3 text-600 overflow-hidden white-space-nowrap" style="text-overflow: ellipsis">
            <Skeleton width="40%" />
          </div>
          <div class="mb-3 text-600 overflow-hidden white-space-nowrap" style="text-overflow: ellipsis">
            <Skeleton width="50%" />
          </div>

          <div v-if="!isLeads" class="mb-2 text-600 overflow-hidden white-space-nowrap flex flex-row gap-2">
            <Skeleton width="30%" />
            <Skeleton width="30%" />
            <Skeleton width="30%" />
          </div>
        </div>

        <!-- <Divider /> -->

        <div
          v-if="!isLeads"
          class="surface-900"
          style="
            height: 100px;
            width: calc(100% + 2.5rem);
            margin-left: -1.25rem;
            margin-right: -1.25rem;
            padding-left: 1.25rem;
            padding-right: 1.25rem;
            padding-top: 0.75rem;
            padding-bottom: 0.75rem;
            margin-bottom: -1.25rem;
          "
        >
          <div class="w-full flex flex-row justify-content-evenly align-items-center gap-2 h-full">
            <Skeleton class="cursor-pointer w-full h-full relative lg-item"> </Skeleton>
            <Skeleton class="cursor-pointer w-full h-full relative lg-item"> </Skeleton><Skeleton class="cursor-pointer w-full h-full relative lg-item"> </Skeleton
            ><Skeleton class="cursor-pointer w-full h-full relative lg-item"> </Skeleton>
          </div>
        </div>
      </template>

      <template v-if="!isLeads" #footer>
        <div
          class="flex align-items-center justify-content-between pt-3"
          style="
            border-top: 1px solid rgba(0, 0, 0, 0.15);
            width: calc(100% + 2.5rem);
            margin-left: -1.25rem;
            margin-right: -1.25rem;
            padding-left: 1.25rem;
            padding-right: 1.25rem;
            padding-top: 0.75rem;
            margin-bottom: -0.5rem;
          "
        >
          <div class="text-left flex-grow-1 pb-1">
            <Skeleton width="25%" />
          </div>
          <div class="text-right flex-grow-1 flex justify-content-end pb-1">
            <Skeleton width="45%" />
          </div>
        </div>
      </template>
    </Card>
  </div>
</template>
